import { z } from "zod";

export const TrackingCheckpointItemSchema = z.object({
  message: z.string(),
  checkpoint_time: z
    .string()
    .transform((value) => (value ? new Date(value) : undefined))
    .optional(),
});

export type TrackingCheckpointItemType = z.infer<
  typeof TrackingCheckpointItemSchema
>;
